import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            title: '',
            category: '',
            content: '',
            wr_good: '',
            answerTitle: '',
            answerContent: '',
            type: 1,
            link: '',
            reviewComment: '',
            ar_comment: [],
            File: [],
            HashTags: [],
            main: 0,
            dateRange: null,
            use: 1,
            bc_idx: '',
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        category: function (value) {
            return Validator.value(value)
                .required('카테고리를 선택해주세요.');
        },
        bc_idx: function (value) {
            return Validator.value(value)
                .required('분류를 선택해주세요.');
        },
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi, "");
                        if (content.length === 0) {
                            return '내용을 입력해주세요.'
                        }
                    }
                )
        },
        answerTitle: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.');
        },
        answerContent: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi, "");
                        if (content.length === 0) {
                            return '내용을 입력해주세요.'
                        }
                    }
                )
        },

        type: function (value) {
            return Validator.value(value)
                .required('타입을 선택해주세요.');
        },

        link: function (value) {
            return Validator.value(value)
                .required('링크를 입력해주세요.')
                .custom(
                    () => {
                        let re = /^(((http(s?))\:\/\/)?)([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/;
                        if (!re.test(value)) {
                            return '링크를 올바르게 입력해주세요.'
                        }
                    }
                )
        },

        reviewComment: function (value) {
            return Validator.value(value)
                .required('리뷰 답변을 입력해주세요.')
                .custom(
                    () => {
                        if (value.length > 500) {
                            return '리뷰 답변은 500자까지만 가능합니다.'
                        }
                    }
                )
        },

        File: function (value) {
            return Validator.value(value)
                .required('파일을 등록해주세요.')
        },

        rollingMobile: function (value) {
            return Validator.value(value)
                .required('파일을 등록해주세요.')
        },

        dateRange: function (value) {
            return Validator.value(value)
                .required('기간을 설정해주세요.');
        },
    },
    methods: {},
    computed: {},
}
